"use strict";
var Observable_1 = require("../../Observable");
var race_1 = require("../../operator/race");
Observable_1.Observable.race = race_1.raceStatic;
//# sourceMappingURL=race.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/observable/race.js
 ** module id = 225
 ** module chunks = 1
 **/